export function compareOptions(a: string, b: string) {
  return a.localeCompare(b);
}
